import { Empty } from "antd5";

import { DispatchComponentProps } from "components/reports/Section";
import { IframeSection as iIframeSection } from "lib/generated/admin-api";

export default function IframeSection({
  section,
  reportSectionId,
}: DispatchComponentProps<iIframeSection>): JSX.Element {
  return (
    <div id={reportSectionId}>
      {section.src ? (
        <iframe
          // Allowed sources are done via the CSP + during report creation so we don't need to do any validation here
          // See app/javascript/components/reports/builder_components/IframeEditor.tsx for the list of allowed domains + links to other relevant files
          src={section.src}
          style={{
            backgroundColor: "transparent",
            border: "none",
            width: "100%",
            height: "100%",
            minHeight: 600,
          }}
          // There isn't a way to deny-all annoyingly. The only permissions I think are dangerous are "fullscreen" and "clipboard-read"
          // but we need fullscreen for video embeds so just disabling clipboard-read. Have explicitly added
          // autoplay, fullscreen & picture-in-picture since they are needed for video embeds.
          // You can get the list of permissions here but the generator outputs the wrong format https://www.permissionspolicy.com
          allow="autoplay; fullscreen; picture-in-picture; clipboard-read 'none'"
          // Since we don't embed anything from same-origin having both "allow-same-origin" and "allow-scripts" is safe.
          // allow-popups & allow-popups-to-escape-sandbox is so you can open links in a new tab
          sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox allow-downloads"
        />
      ) : (
        <Empty description="Paste an iframe or src to get started" />
      )}
    </div>
  );
}
